import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDropzone } from 'react-dropzone'
import { useNavigate } from 'react-router-dom';
import { useParams, BrowserRouter as Router, Route, Link } from 'react-router-dom';
import './PickupForm.css';
import axios from 'axios';
import header from './assets/images/header.jpg';
import { BsFileEarmarkArrowDown } from "react-icons/bs";
import DatePickerComponent from './DatePickerComponent';
import TermsAndConditions from './documents/termsAndCondition';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { splitCamelCase, sqlDateTime, generateRandomString } from './functions/functions.js';
import Navbar from './Navbar.js';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function TelegraphicTransferForm() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({});
    const [qrImageSrc, setQrImageSrc] = useState('');
    const [uniqueLink, setUniqueLink] = useState('');
    const [isTermsPage, setIsTermsPage] = useState(false);
    const [specialists, setSpecialists] = useState([]);
    const [holidayList, setHolidayLists] = useState([]);
    const marginTopLabel = '30px';

    ///Document handle
    const [selectedFile, setSelectedFile] = useState(null);
    const onDrop = useCallback((acceptedFiles) => {
        setSelectedFile(acceptedFiles[0]);
    }, []);
    const { getRootProps, getInputProps } = useDropzone({ onDrop });


    ///Time slots
    const [selectedDate, setSelectedDate] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState('');


    useEffect(() => {
        fetchHolidayData();
        fetchSpecialistsData();
        generateUniqueLink();
        
    }, []);


    const fetchSpecialistsData = async () => {
        try {
            ///?_=${new Date().getTime()} using to avoid cache issue
            const response = await fetch(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/getSpecialists?_=${new Date().getTime()}`);
            const jsonData = await response.json();

            const specialistsList = jsonData.map(item => item.Specialists);
            setSpecialists(specialistsList);

           
        } catch (error) {
            console.error('Error fetching formData:', error.message);
        }
    };

    const fetchHolidayData = async () => {
        try {
            ///?_=${new Date().getTime()} using to avoid cache issue
            const response = await fetch(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/getHoliday?_=${new Date().getTime()}`);
            const jsonData = await response.json();

            setHolidayLists(jsonData);


        } catch (error) {
            console.error('Error fetching formData:', error.message);
        }
    };

    function generateUniqueLink() {
        setUniqueLink(generateRandomString());
    }

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        const sanitizedValue = newValue === null || newValue === undefined ? '' : newValue;
        setFormValues({
            ...formValues,
            [name]: sanitizedValue
        });
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!selectedTimeSlot) {
            window.alert('You must choose a timeslot to proceed.');
            return;
        }

        const blockInfo = isCanBookCheck();
        if (blockInfo.isBlocked) {
            window.alert("You cannot proceed. " + blockInfo.errorMessage);
            return;
        }

        const malaysiaMoment = moment().tz("Asia/Kuala_Lumpur");
        const selectedMoment = moment(selectedDate).tz("Asia/Kuala_Lumpur");

        // Same day booking check
        if (selectedMoment.isSame(malaysiaMoment, 'day')) {
            window.alert("You cannot book for the same day");
            return;
        }

        const currentMalaysiaTime = moment.tz("Asia/Kuala_Lumpur"); 

        const today = currentMalaysiaTime.clone();
        const tomorrow = today.clone().add(1, 'days'); 

        ///----------------------------------------------------------------------------
        ///Recheck block for today
        const selectedMomentToday = moment.utc(selectedDate).startOf("day");

        if (selectedMomentToday.isSame(today, "day")) {
            window.alert("You cannot book for the same day");
        } 
        ///----------------------------------------------------------------------------

        ///----------------------------------------------------------------------------
        ///Block after 12pm, if next day is holiday, for the next day after holiday

        const isAfter12PM = currentMalaysiaTime.hours() >= 12;

        const tomorrowDateString = tomorrow.format('YYYY-MM-DD'); 
        const tomorrowHoliday = holidayList.find(
            holiday => holiday.HolidayDate.split('T')[0] === tomorrowDateString
        );

        const dayAfterTomorrow = today.clone().add(2, 'days'); 

        const formatSelectedDate = moment(selectedDate).tz("Asia/Kuala_Lumpur").format('YYYY-MM-DD');

        /*
        console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
        console.log(currentMalaysiaTime.format());
        console.log(currentMalaysiaTime.hours());
        console.log(isAfter12PM);
        console.log(tomorrowDateString);
        console.log(tomorrowHoliday);
        console.log(selectedDate)
        console.log(formatSelectedDate);
        console.log(dayAfterTomorrow.format('YYYY-MM-DD')); 

      */
 
        if (isAfter12PM && tomorrowHoliday && formatSelectedDate === dayAfterTomorrow.format('YYYY-MM-DD')) {
            window.alert("You cannot proceed. After 12pm, no appointment is allowed for the next day of the holiday.");
            return;
        }
      
         ///----------------------------------------------------------------------------

        const sanitizeValue = (value) => value || '';
       
        const confirmed = window.confirm("Are you sure you want to submit the form?");
        if (confirmed) {
            try {
                const response = await fetch(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/formSubmit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    }, 
                    body: JSON.stringify({
                        Email: sanitizeValue(formValues.Email),
                        PatientName: sanitizeValue(formValues.PatientName),
                        PatientPassportNum: sanitizeValue(formValues.PatientPassportNum),
                        HPNumber: sanitizeValue(formValues.HPNumber),
                        Specialists: sanitizeValue(formValues.Specialists),
                        CompanionsName: sanitizeValue(formValues.CompanionsName),
                        CompanionsPassportNum: sanitizeValue(formValues.CompanionsPassportNum),
                        Airline: sanitizeValue(formValues.Airline),
                        FlightNumber: sanitizeValue(formValues.FlightNumber),
                        FlightItinerary: selectedFile ? `${selectedFile.name.split('.').pop()}` : '',
                        TargetDate: selectedDate,
                        TimeSlot: selectedTimeSlot,
                        Remarks: sanitizeValue(formValues.Remarks),
                        CreateByDate: sqlDateTime(moment().tz("Asia/Kuala_Lumpur").toDate()),
                        Status: "Pending",
                        UniqueLink: uniqueLink,
                        
                    }),
                })
                if (response.ok) {
                
                        if (selectedFile) {
                            uploadDocuments();
                        }
                        handleEmail()

                        navigate('/formSubmit', { state: { formAction: "Submitted" } });
                  
                } else {
                    window.alert('Fail to submit form, please try again.');
                }
            } catch (error) {
                window.alert('Fail to submit form, please try again.');
            }
        }
    };



    async function handleEmail() {
        try {
            const response = await fetch(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/submit-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PatientName: formValues.PatientName,
                    TargetDate: selectedDate,
                    TimeSlot: selectedTimeSlot,
                }),
            });
            if (response.ok) {
                console.log("Send email")
            }
        } catch (error) {
            console.log('Error sending email:', error);

        }
    }

    ///-------------------------------Documents handle-------------------------------------
 
    async function uploadDocuments() {
        try {
            const documentData = new FormData();
            documentData.append('file', selectedFile);
            documentData.append('uniqueLink', uniqueLink);

            const dangerousFileTypes = ['application/vnd.android.package-archive', 'application/x-msdownload', 'application/x-msi'];

            // Check if selected document is not dangerous file and is below 12MB
            if (!dangerousFileTypes.includes(selectedFile.type) && selectedFile.size < 12 * 1024 * 1024) {
                await axios.post(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/uploadDocument`, documentData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            } else {
                console.log("Document format not supported or size exceeds 12MB limit.");
            }
        } catch (error) {
            console.log("Error uploading document: " + error);
        }
    }
    ///--------------------------------------------------------------------------------------

    ///Read status and return
    //if (formData.length === 0) {
     //   return (
     //       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      //          <h1>No Form available</h1>
       //     </div>
       // );
    //}



    const handleNextClick = () => {
        if (!formValues.AgreeToStatement) {
            window.alert('You must agree to the statement to proceed.');
            return;
        }
        setIsTermsPage(true);
        ScrollToTop();
    };
    const handlePreviousClick = () => {
        setIsTermsPage(false);
        ScrollToTop();
    };

  
    const ScrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
    };            


    ///-----------------------------------Time slot-----------------------------------------
    useEffect(() => {
        if (selectedDate) {
            const day = moment(selectedDate).day();
            let slots = [];
            if (day >= 1 && day <= 5) {
                slots = ['10:30am', '12:30pm', '2:30pm', '4:30pm', '6:30pm', '8:30pm', '10:00pm'];
            } else if (day === 6) {
                slots = ['10:30am', '12:30pm', '6:30pm'];
            } else if (day === 0) {
                slots = ['10:30am', '12:30pm', '2:30pm', '4:30pm', '6:30pm', '10:00pm'];
            }
            setTimeSlots(slots);
        }
    }, [selectedDate]);

    const handleDateChange = date => {

        const consistanceDate = new Date(
            Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0,
                0,
                0,
            )
        );

        setSelectedDate(consistanceDate);
    };

    const handleTimeSlotSelect = slot => {
        setSelectedTimeSlot(slot);

    };
    ///--------------------------------------------------------------------------------------



    const downloadLinkRef = useRef(null);

    const handleDownload = () => {
        downloadLinkRef.current.click();
    };

    const isDateSelectable = date => {
        return moment(date).isSameOrAfter(moment().add(1, 'days'), 'day');
    };

    const isAIrportBlockAccess = () => {
        const malaysiaMoment = moment().tz("Asia/Kuala_Lumpur");
        const dayOfWeek = malaysiaMoment.day();
        const malaysiaHour = malaysiaMoment.hour();

        const blockMessageContainer = (message) => (
            <div className="form-container">
                <div className="header-container">
                    <img src={header} alt="Header" className="header-image" />
                </div>
                <div className="block-message-container">
                    <div className="block-message-box">
                        <h2>Notice</h2>
                        <p>{message}</p>
                        <div className="block-message-icon">🕒</div>
                    </div>
                </div>
            </div>
        );

        // 1. Sunday Blocking
        if (dayOfWeek === 0) {
            return blockMessageContainer(
                "No appointment is allowed on Sunday. You may submit your request on our next working day."
            );
        }

        // 2. Saturday After 11am Blocking
        if (dayOfWeek === 6 && malaysiaHour >= 11) {
            return blockMessageContainer(
                "No appointment is allowed after 11am on Saturday. You may submit your request on our next working day."
            );
        }

        // 3. Holiday Blocking
        const todayDateString = malaysiaMoment.format('YYYY-MM-DD');
        const holiday = holidayList.find(holiday => holiday.HolidayDate.split('T')[0] === todayDateString);

        if (holiday) {
            return blockMessageContainer(
                `Today is ${holiday.HolidayName}, no appointment is allowed.`
            );
        }
    };


    ///Check after click submit
    const isCanBookCheck = () => {
        const malaysiaMoment = moment().tz("Asia/Kuala_Lumpur");
        let blockedInfo = { isBlocked: false, errorMessage: '' };

        // Helper function to check if a date is a holiday
        const isHoliday = (date) => {
            const dateStr = date.format('YYYY-MM-DD');
            return holidayList.find(holiday => holiday.HolidayDate.split('T')[0] === dateStr);
        };

        // Check consecutive holidays
        const checkConsecutiveHolidays = () => {
            const nextDays = [];
            for (let i = 1; i <= 7; i++) {
                const nextDay = malaysiaMoment.clone().add(i, 'days');
                nextDays.push({
                    date: nextDay,
                    isHoliday: isHoliday(nextDay)
                });
            }
            return nextDays;
        };

        const consecutiveHolidays = checkConsecutiveHolidays();
        const selectedMoment = moment(selectedDate).tz("Asia/Kuala_Lumpur");

        // Basic checks
        if (malaysiaMoment.day() === 0) {
            blockedInfo.isBlocked = true;
            blockedInfo.errorMessage = 'Today is Sunday, no appointment is allowed.';
            return blockedInfo;
        }

        if (isHoliday(malaysiaMoment)) {
            blockedInfo.isBlocked = true;
            blockedInfo.errorMessage = 'Today is a holiday, no appointment is allowed.';
            return blockedInfo;
        }

        // Complex holiday blocking logic
        const isAfter12PM = malaysiaMoment.hour() >= 12;
        const isSaturdayAfter11AM = malaysiaMoment.day() === 6 && malaysiaMoment.hour() >= 11;

        // Find first non-holiday weekday
        let firstAvailableDay = null;
        for (let i = 0; i < consecutiveHolidays.length; i++) {
            const day = consecutiveHolidays[i];
            if (!day.isHoliday && day.date.day() !== 0) { // Not a holiday and not Sunday
                firstAvailableDay = day.date;
                break;
            }
        }

        // Blocking rules for consecutive holidays
        if (firstAvailableDay) {
            const daysUntilAvailable = firstAvailableDay.diff(malaysiaMoment, 'days');
            
            // If there are consecutive holidays coming up
            if (daysUntilAvailable > 1) {
                // After 12 PM, block next available day
                if (isAfter12PM || isSaturdayAfter11AM) {
                    if (selectedMoment.isBefore(firstAvailableDay)) {
                        blockedInfo.isBlocked = true;
                        blockedInfo.errorMessage = `Due to upcoming holidays, appointments can only be made for ${firstAvailableDay.format('DD/MM/YYYY')} or later.`;
                        return blockedInfo;
                    }
                }
            }
        }

        // Next day booking cutoff at 12 PM
        const nextDay = malaysiaMoment.clone().add(1, 'day');
        if (selectedMoment.isSame(nextDay, 'day') && isAfter12PM) {
            blockedInfo.isBlocked = true;
            blockedInfo.errorMessage = 'Appointment should be made at least one day before cut off time at 12pm.';
            return blockedInfo;
        }

        return blockedInfo;
    };


    return (
        <div>
            <Navbar currentPage='PickupForm' />
            {isAIrportBlockAccess() ? isAIrportBlockAccess() : 
            <div className="form-container">
                    <div className="header-container">
                        <img src={header} alt="Header" className="header-image" />
                    </div>
                {isTermsPage ? (
                        <form onSubmit={handleFormSubmit}>
                          
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', top: '-10px', right: '-25px' }}>
                                {qrImageSrc && <img src={qrImageSrc} alt="QR Code" className="logo-img" />}
                            </div>
                        </div>
                        <h1>ISLAND HOSPITAL AIRPORT PICK UP SERVICE REQUEST FORM</h1>
                        <div>
                            <hr />
                        </div>
                        <span style={{ color: 'red', fontSize: '0.8em' }}>* is a required field</span>

                    
                        <label style={{ marginTop: marginTopLabel }}>Email<span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="email"
                                name="Email"
                                value={formValues.Email}
                                onChange={handleFormChange}
                                maxLength={50}
                                required
                            />
                            <label style={{ marginTop: marginTopLabel }}>Patient's Name(as per passport)<span style={{ color: 'red' }}>*</span></label>
                            <input
                                name="PatientName"
                                value={formValues.PatientName}
                                onChange={handleFormChange}
                                required
                            />                     
                        <label style={{ marginTop: marginTopLabel }}>Patient's Passport Number<span style={{ color: 'red' }}>*</span></label>
                            <input
                                name="PatientPassportNum"
                                value={formValues.PatientPassportNum}
                                onChange={handleFormChange}
                                maxLength={50}
                                required
                            />
                            <label style={{ marginTop: marginTopLabel }}>H/P Number<span style={{ color: 'red' }}>*</span></label>
                            <input
                                name="HPNumber"
                                value={formValues.HPNumber}
                                onChange={handleFormChange}
                                maxLength={20}
                                required
                            />
                

                        <label className="selectLabel" style={{ marginTop: marginTopLabel }}>Specialists<span style={{ color: 'red' }}>*</span></label>
                        <select
                            name="Specialists"
                            value={formValues.Specialists}
                            onChange={handleFormChange}
                            required
                        >
                            <option value="" key=""></option>
                            {specialists.map((specialist, index) => (
                                <option key={index} value={specialist}>
                                    {specialist}
                                </option>
                            ))}
                        </select>

                        <label className="checkboxLabel" style={{ marginTop: marginTopLabel }}>
                            <div className="checkbox-containers companion-checkbox">
                                <div className="checkbox-container1">
                                    <input
                                        name="HasCompanion"
                                        type="checkbox"
                                        checked={formValues.HasCompanion}
                                        onChange={handleFormChange}
                                    />
                                </div>
                                <div className="checkbox-container2">
                                    <p>I have a companion</p>
                                </div>
                            </div>
                        </label>

                        {formValues.HasCompanion && (
                            <>
                                <label style={{ marginTop: marginTopLabel }}>Companion's Name (as per passport)<span style={{ color: 'red' }}>*</span></label>
                                <input
                                    name="CompanionsName"
                                    value={formValues.CompanionsName}
                                    onChange={handleFormChange}
                                    required
                                />

                                <label style={{ marginTop: marginTopLabel }}>Companion's Passport Number<span style={{ color: 'red' }}>*</span></label>
                                <input
                                    name="CompanionsPassportNum"
                                    value={formValues.CompanionsPassportNum}
                                    onChange={handleFormChange}
                                    required
                                />
                            </>
                        )}

                        <label style={{ marginTop: marginTopLabel }}>Airline<span style={{ color: 'red' }}>*</span></label>
                        <input
                            name="Airline"
                            value={formValues.Airline}
                            onChange={handleFormChange}
                            required
                        />

                        <label style={{ marginTop: marginTopLabel }}>Flight Number<span style={{ color: 'red' }}>*</span></label>
                        <input
                            name="FlightNumber"
                            value={formValues.FlightNumber}
                            onChange={handleFormChange}
                            required
                        />

                        <label style={{ marginTop: marginTopLabel }}>Flight Itinerary</label>
                        <div {...getRootProps()} className="dropzone">
                            <input {...getInputProps()} />
                            {!selectedFile && (
                            <div>
                                <p>Drop a picture / pdf here, or click to select a file</p>
                                    <BsFileEarmarkArrowDown />
                                </div>
                            )}
                            {selectedFile && (
                                <div>
                                <p className="file-info">
                                    Selected file: {selectedFile.name} ({selectedFile.size} bytes)
                                    </p>
                                
                                </div>
                            )}
                        </div>

             
                            <div style={{ marginTop: '30px' }} />
                            <div className="flex-container">
                                <div className="date-picker-container" style={{ marginRight: '20px' }}>
                                    <DatePicker
                                        selected={selectedDate}
                                        onChange={handleDateChange}
                                        filterDate={isDateSelectable}
                                        inline
                                        required
                                    />
                                </div>
                                <div className="time-slot-container">
                                    <h3>Select a Malaysia Time Slot</h3>
                                    {timeSlots.length === 0 && <p>Please select a date.</p>}
                                    <div className="time-slots">
                                        {timeSlots.map((slot, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                onClick={() => handleTimeSlotSelect(slot)}
                                                className={`time-slot-button ${selectedTimeSlot === slot ? 'selected' : ''}`}
                                            >
                                                {slot}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                    


                        <label style={{ marginTop: marginTopLabel }}>Remarks (If Any)</label>
                        <input
                            name="Remarks"
                            value={formValues.Remarks}
                            onChange={handleFormChange}
                            maxLength={1000}
                        />

                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px' }}>
                                <input
                                    type="button"
                                    className="submitButton previousButton"
                                    value="Previous"
                                    onClick={handlePreviousClick}
                                    style={{ marginRight: '100px' }} // Adjust margin for spacing
                                />
                                <input
                                    type="submit"
                                    className="submitButton submitButton"
                                    value="Submit"
                                />
                            </div>
                    </form>
                ) : (
                        <form>
                                <div className="form-container">
                                    <h1>Terms and Conditions</h1>
                                    <hr />

                                    <TermsAndConditions />

                                    <h4 className="italic-text">
                                        BY REGISTERING ISLAND HOSPITAL AIRPORT PICK UP, PATIENT AGREES HAS READ AND UNDERSTANDED ALL TERMS AND CONDITIONS AND AGREE TO THE TERMS AND CONDITIONS AS ABOVE.
                                    </h4>

                                    <label className="checkboxLabel">
                                        <div className="checkbox-containers">
                                            <div className="checkbox-container1">
                                                <input
                                                    name="AgreeToStatement"
                                                    type="checkbox"
                                                    checked={formValues.AgreeToStatement}
                                                    onChange={handleFormChange}
                                                    required
                                                />
                                            </div>
                                            <div className="checkbox-container2">
                                                <p>I agree to <a className='terms-link' onClick={handleDownload}>terms & conditions.</a></p>
                                                <a href="/Island Hospital Pick Up Service Term & Condition (English)_250624.pdf" download ref={downloadLinkRef} style={{ display: 'none' }}>Download</a>
                                            </div>
                                        </div>
                                    </label>

                                    <div className="button-container">
                                        <input
                                            type="submit"
                                            className="submitButton"
                                            value="Next"
                                            onClick={handleNextClick}
                                        />
                                    </div>
                                </div>
                            </form>
                )}
                </div>
            }
        </div>
      
    );
};

export default TelegraphicTransferForm;